import React from "react";
import styles from "./index.module.scss";

const Toggle = (props) => {
  const { title } = props;
  return (
    <label className={styles.root} htmlFor={props.id}>
      <input {...props} checked={Boolean(props.value)} type="checkbox" />
      <div className={styles.switcher}>
        <div />
      </div>
      {title && <span className={styles.title}>{title}</span>}
    </label>
  );
};

export default Toggle;
